<template>
    <div id="myinfo-register-password-2">
      <f7-list form class="form-group">
        <f7-list-input
          input-id      ="singpassPassword2"
          name          ="singpassPassword2"
          :type         ="singpassPassword2InputType"
          class         ="password"
          placeholder   =""
          @input        ="onInput($event)"
          minlength     ="8"
          :label        ="$t('general-text-reenter-password')"
          outline
          floating-label
          required
        >
          <div class="toggle-password" @click="showHidePassword('singpassPassword2')" id="singpass-password-icon2" toggle="#singpass-password-field2" slot="content-end" style="">
            <i class="f7-icons">eye_slash</i>
          </div>
        </f7-list-input>
    </f7-list>
  </div>
</template>

<script>
  //import { mapGetters, mapActions } from "vuex";
  
  export default {
    props: {
      singpassPassword2InputType:{
        type: String
      },
    },
    mounted (){
      
    },
    data: function () {
      return {
      }
    },
    computed: {

    },
    methods: {
      showHidePassword(el){
        this.$emit("showHidePassword", el);
      },

      async onInput(e){
        await this.setPassword2(e.target.value);
        await this.validateInput(e.target);
        this.validateNextButton()
      },

      async setPassword2(val){
        this.$emit("setPassword2", val);
      },

      async validateInput(e){
        this.$emit("validateInput", e);
      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }
    }
  }
</script>